// https://fonts.google.com/icons
export default [
    ['trash', require(`@material-icons/svg/svg/delete/baseline.svg`)],
    ['search', require(`@material-icons/svg/svg/search/baseline.svg`)],
    ['backspace', require(`@material-icons/svg/svg/backspace/baseline.svg`)],
    ['plus', require(`@material-icons/svg/svg/add/baseline.svg`)],
    ['print', require(`@material-icons/svg/svg/print/baseline.svg`)],
    ['refresh', require(`@material-icons/svg/svg/refresh/baseline.svg`)],
    ['download', require(`@material-icons/svg/svg/download/baseline.svg`)],
    ['upload-cloud', require(`@material-icons/svg/svg/cloud_upload/baseline.svg`)],

    ['cancel', require('@material-icons/svg/svg/cancel/baseline.svg')]
    ['error', require('@material-icons/svg/svg/error/baseline.svg')],
    ['close', require('@material-icons/svg/svg/close/baseline.svg')],
    ['chevron_left', require(`@material-icons/svg/svg/chevron_left/baseline.svg`)],
    ['chevron_right', require(`@material-icons/svg/svg/chevron_right/baseline.svg`)],

    ['check-box', require('../legacy/check-box.svg.html')],
	['check-box-active', require('../legacy/check-box-active.svg.html')],

    // TODO: update BUI code to use real icon name
    ['cancel-circled', 'cancel'],
]